module.exports = __webpack_public_path__ + "img/ticket@2x-100.4362debc.jpg";